<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { ContentBlock } from '~/components/ui/content-block'
import { WidgetUser, WidgetUserWide } from '~/components/widget/user'
import { FeatureContactPageForm } from '~/components/feature/contact-page/form'
import type { IResponseData } from '~/types'
import type { IUser } from '~/components/entity/user'

const { t } = useI18n()

const { data: authorsData } = await useApi<IResponseData<IUser[]>>(
  () => useUrlWithParams('/authors', {}),
  {
    key: 'authors_list'
  }
)

const authors = computed(() => authorsData.value?.data || [])
const featuredAuthors = computed(() => authors.value.slice(0, 3))
const remainingAuthors = computed(() => authors.value.slice(3))

const breadcrumbs = computed(() => [{ title: t('common.authors'), url: '/authors' }])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />

      <div class="space-y-5">
        <ContentBlock :heading-text="t('page.authors.featured_authors')">
          <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            <WidgetUser
              v-for="(author, index) in featuredAuthors"
              :key="author.id"
              v-bind="author"
              variant="white"
              show-news
              :index="index + 1"
              :hide-contacts="false"
            />
          </div>
        </ContentBlock>

        <ContentBlock
          v-if="remainingAuthors.length > 0"
          :heading-text="t('page.authors.all_authors')"
        >
          <div class="space-y-4">
            <WidgetUserWide
              v-for="author in remainingAuthors"
              :key="author.id"
              v-bind="author"
              variant="white"
              show-news
            />
          </div>
        </ContentBlock>
        <FeatureContactPageForm
          variant="white"
          heading-tag="h3"
          :heading-text="t('page.authors.become_author_heading')"
        >
          <template #description>
            <p class="mb-5 text-gray-600">{{ t('page.authors.become_author_text') }}</p>
          </template>
        </FeatureContactPageForm>
      </div>
    </Container>
  </Main>
</template>
